import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPhone, FaEnvelope, FaSearch, FaTimes, FaLongArrowAltRight } from "react-icons/fa";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import Header_Logo from '../images/logo/Zamindaar Infra (White).png';
import Popup_Img from '../images/logo/Zamindaar Infra (White).png';
import linkedin from '../images/linkedin.png';
import facebook from '../images/facebook.png';
import twitter from '../images/twitter.png';
import instagram from '../images/instagram.png';
import whatsapp from '../images/whatsapp.png'
import projects from '../data/ProjectsData';
import youtube from '../images/youtube.png'
import './Header.css'

function Header() {
    const [showModal, setShowModal] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ name: "", mobile: "", email: "", message: "" });
    const [loading, setLoading] = useState(false);
    const [showIntro, setShowIntro] = useState(false);
    const [introAccepted, setIntroAccepted] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    // Hide intro popup on privacy policy page
    useEffect(() => {
        if (location.pathname === '/privacy-policy') {
            setShowIntro(false);
        }
    }, [location.pathname]);

    // Intro disclaimer logic
    useEffect(() => {
        const hasSeenIntro = localStorage.getItem('tattva_intro_seen');
        if (!hasSeenIntro) {
            setShowIntro(true);
        } else {
            setIntroAccepted(true);
        }
    }, []);

    // Optional: Show enquiry modal 3s after intro accepted and on contact page
    useEffect(() => {
        if (introAccepted && location.pathname === '/contact-us') {
            const timer = setTimeout(() => setShowModal(true), 3000);
            return () => clearTimeout(timer);
        }
    }, [introAccepted, location.pathname]);

    // Close intro and mark accepted
    const handleIntroAgree = () => {
        localStorage.setItem('zamindaar_intro_seen', 'true');
        setShowIntro(false);
        setIntroAccepted(true);
    };

    // Close enquiry modal
    const handleCloseModal = () => setShowModal(false);

    // Toggle search overlay
    const toggleSearch = () => setShowSearch(!showSearch);

    // Search form submit handler
    const handleSearch = (e) => {
        e.preventDefault();
        if (!searchQuery.trim()) return;

        const query = searchQuery.toLowerCase().trim();

        const projectRoutes = {
            flat: '/projects/flats',
            flats: '/projects/flats',
            villa: '/projects/villas',
            villas: '/projects/villas',
            plot: '/projects/plots',
            plots: '/projects/plots',
            commercial: '/projects/commercials',
            commercials: '/projects/commercials',
        };

        // Find exact project match by name
        const matchedProject = projects.find(p => p.project_name.toLowerCase().includes(query));

        if (matchedProject) {
            navigate(`/projects/${matchedProject.id}`);
        } else {
            // Otherwise route by category keyword
            const matchedRouteKey = Object.keys(projectRoutes).find(key => query.includes(key));
            if (matchedRouteKey) {
                navigate(projectRoutes[matchedRouteKey]);
            } else {
                // Default fallback
                navigate('/projects/flats');
            }
        }

        setSearchQuery("");
        setShowSearch(false);
    };

    // Enquiry form change handler
    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    // Enquiry form submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                "https://peracause.com/backend-files/tattva/contact-tattva.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams(formData).toString()
                }
            );

            const result = await response.json();
            alert(result.message);

            if (result.status === "success") {
                setFormData({ name: "", mobile: "", email: "", message: "" });
                setShowModal(false);
            }
        } catch (error) {
            alert("Error submitting the form. Please try again.");
        }

        setLoading(false);
    };

    return (
        <header>
            {/* Top Contact Bar */}
            {/* Top Bar */}
            <div className="header-top py-2 container-fluid d-flex justify-content-center bg-dark">
                <div className="container d-flex align-items-center row">
                    <div className="d-flex justify-content-around col-lg-9 col-md-8 col-4">
                        <a href="mailto:support@zamindaarinfra.co.in" className="header-contact text-light d-flex align-items-center">
                            <FaEnvelope className="me-2" />
                            <span className="d-md-block d-none">support@zamindaarinfra.co.in</span>
                        </a>
                        <div className="d-flex gap-3 align-items-center">
                            <a href="tel:+918897035800" className="header-phone text-light d-flex align-items-center">
                                <FaPhone className="me-2" />
                                <span className="d-md-block d-none">+91 88970 35800</span>
                            </a>
                            <p className="text-white mb-0">|</p>
                            <a href="tel:+918897035800" className="header-phone text-light d-flex align-items-center">
                                <FaPhone className="me-2" />
                                <span className="d-md-block d-none">+91 73966 0274</span>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-8 d-flex justify-content-end">
                        <div className="header-social d-flex align-items-center gap-1">
                            <a href="https://whatsapp.com/channel/0029Va6Bzio1NCrLOiBprT2e" target="_blank" rel="noreferrer"><img src={whatsapp} alt="LinkedIn" className="w-50" /></a>
                            <a href="https://www.linkedin.com/in/tattva-hi-life-735094319/" target="_blank" rel="noreferrer"><img src={linkedin} alt="LinkedIn" className="w-50" /></a>
                            <a href="https://x.com/TattvaHiLife" target="_blank" rel="noreferrer"><img src={twitter} alt="Twitter" className="w-50" /></a>
                            <a href="https://www.facebook.com/profile.php?id=100086552704523" target="_blank" rel="noreferrer"><img src={facebook} alt="Facebook" className="w-50" /></a>
                            <a href="https://www.instagram.com/tattvahilife_international/" target="_blank" rel="noreferrer"><img src={instagram} alt="Instagram" className="w-50" /></a>
                            <a href="https://www.youtube.com/" target="_blank" rel="noreferrer"><img src={youtube} alt="Instagram" className="w-75" /></a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Logo + Navbar */}
            <div className="header-middle bg-black text-light py-1">
                <div className="container d-flex justify-content-between align-items-center">
                    <Link to="/" className="header-logo">
                        <img src={Header_Logo} alt="Zamindaar Infra Logo" className="img-fluid" />
                    </Link>

                    <nav className="navbar navbar-expand-lg navbar-dark">
                        <div className="container-fluid">
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNav">
                                <ul className="navbar-nav ms-auto">
                                    <li className="nav-item">
                                        <NavLink end className="nav-link" to="/">Home</NavLink>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="projectsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Projects
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="projectsDropdown">
                                            <li><NavLink className="dropdown-item" to="/projects/flats">Flats</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/villas">Villas</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/plots">Plots</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/commercials">Commercial</NavLink></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="locationsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Locations
                                        </a>
                                        <ul className="dropdown-menu" aria-labelledby="locationsDropdown">
                                            <li><NavLink className="dropdown-item" to="/hyderabad">Hyderabad</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/dubai">Dubai</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/banglore">Bangalore</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/pune">Pune</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/mumbai">Mumbai</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/delhiNCR">Delhi NCR</NavLink></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/landowner-share" rel="noopener noreferrer">
                                            Landowner Share
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/facility-management">Facility Management</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/about">About Us</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/contact-us">Contact Us</NavLink>
                                    </li>

                                    <li className="nav-item d-flex align-items-center">
                                        <button onClick={toggleSearch} className="btn text-rose ms-3" aria-label="Search">
                                            <FaSearch />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>

                    {/* Enquire Now button (visible on lg and above) */}
                    <div className="d-none d-lg-block">
                        <button className="btn enquire-btn text-rose" onClick={() => setShowModal(true)}>
                            <span className="fs-3">→</span> Enquire Now
                        </button>
                    </div>
                </div>
            </div>

            {/* Search Overlay */}
            {showSearch && (
                <div className="search-overlay position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75 d-flex justify-content-center align-items-start z-1050">
                    <div className="search-container position-relative w-100 bg-black p-3" style={{ maxWidth: '400px' }}>
                        <form onSubmit={handleSearch} className="d-flex justify-content-center align-items-center">
                            <input
                                type="text"
                                className="form-control me-2"
                                placeholder="Search projects..."
                                value={searchQuery}
                                onChange={e => setSearchQuery(e.target.value)}
                                autoFocus
                            />
                            <button type="submit" className="btn text-rose"><FaSearch /></button>
                            <button type="button" className="btn text-rose ms-2" onClick={toggleSearch}><FaTimes /></button>
                        </form>
                    </div>
                </div>
            )}

            {/* Enquiry Modal */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body row p-4 flex-wrap-reverse">
                                <div className="col-lg-4 d-flex align-items-center justify-content-center">
                                    <div className="text-center">
                                        <img src={Popup_Img} alt="Support" className="mb-3" style={{ width: '100px', height: '100px' }} />
                                        <h4 className="text-rose">+91 99999 99999</h4>
                                        <p className="text-secondary">Make a call</p>
                                    </div>
                                </div>
                                <div className="divider col-lg-1 d-none d-lg-block"><div className="vertical-line"></div></div>
                                <div className="col-lg-7 position-relative d-flex align-items-center">
                                    <div
                                        className="position-absolute end-0 top-0 cursor-pointer"
                                        style={{ zIndex: 10 }}
                                        onClick={handleCloseModal}
                                        aria-label="Close modal"
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => { if (e.key === 'Enter') handleCloseModal(); }}
                                    >
                                        <i className="fas fa-times text-rose fs-3"></i>
                                    </div>
                                    <div className="w-100">
                                        <form onSubmit={handleSubmit}>
                                            <h4 className="mb-4 text-rose">Enquire Now</h4>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                placeholder="Enter your Name"
                                                onChange={handleChange}
                                                className="form-control mb-3"
                                                required
                                            />
                                            <input
                                                type="text"
                                                name="mobile"
                                                value={formData.mobile}
                                                placeholder="Enter your Phone Number"
                                                onChange={handleChange}
                                                className="form-control mb-3"
                                                required
                                            />
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                placeholder="Enter your Email"
                                                onChange={handleChange}
                                                className="form-control mb-3"
                                                required
                                            />
                                            <textarea
                                                name="message"
                                                value={formData.message}
                                                placeholder="Type your message here"
                                                rows="3"
                                                onChange={handleChange}
                                                className="form-control mb-3"
                                                required
                                            />
                                            <div className="text-start mt-3 d-flex align-items-center">
                                                <span className="fs-3 me-2 text-rose">→</span>
                                                <button type="submit" className="btn border-0 text-rose enquire-btn" disabled={loading}>
                                                    {loading ? "Sending..." : "Submit"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Intro Disclaimer Popup */}
            {showIntro && (
                <>
                    <div className="intro-overlay position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75" style={{ zIndex: 1050 }}></div>

                    <div
                        className="intro-popup position-fixed top-50 start-50 translate-middle bg-white text-dark p-4 p-md-5 rounded shadow"
                        style={{ maxWidth: '700px', width: '90%', zIndex: 1051 }}
                    >
                        <div className="text-center">
                            <h5 className="fw-bold mb-3 text-rose sine-title">Welcome to www.zamindaar.co.in</h5>
                            <p className="small text-secondary text-start" style={{ lineHeight: '1.6' }}>
                                Thank you for visiting Zamindaar Infra. Please carefully read the following disclaimer, which applies to the entire website.<br /><br />
                                This website is currently being updated in accordance with TS RERA rules and regulations.<br /><br />
                                By accessing this website, you acknowledge and confirm that all information including images, brochures, and marketing material are for informational purposes only.<br /><br />
                                Details on the website are subject to change without prior notice. We advise you to verify all information with our authorized sales team before making any decisions.<br /><br />
                                The contents here do not constitute an offer, booking, or invitation to purchase a property, and are not legally binding in any way.<br /><br />
                                Zamindaar Infra shall not be held responsible for any reliance placed on this information by the user.
                            </p>
                            <p className="small mt-3 text-secondary text-start">
                                We use cookies to enhance your browsing experience.{" "}
                                <Link
                                    to="/privacy-policy"
                                    className="text-decoration-underline text-rose"
                                    onClick={() => setShowIntro(false)}
                                >
                                    Learn more
                                </Link>
                            </p>
                            <button onClick={handleIntroAgree} className="btn btn-rose mt-3 px-4">
                                I Agree
                            </button>
                        </div>
                    </div>
                </>
            )}
        </header>
    );
}

export default Header;
